var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control-panel-container" }, [
    _c("ul", { staticClass: "list-unstyled" }, [
      _vm.componentName == "table-component"
        ? _c("li", { staticClass: "tasks" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control-item-content open" },
              [
                _vm._l(_vm.batchActions, function(action, idx) {
                  return [
                    idx > 0 ? _c("hr") : _vm._e(),
                    _vm._v(" "),
                    action.name == "active"
                      ? _c(
                          "div",
                          {
                            staticClass: "control-item-switch text-center mb-4"
                          },
                          [
                            _c(
                              "label",
                              {
                                class: [
                                  "col-form-label",
                                  "mr-4",
                                  "d-inline",
                                  _vm.currentSelectedActive
                                    ? "text-secondary"
                                    : "text-default"
                                ]
                              },
                              [_vm._v("Disable")]
                            ),
                            _vm._v(" "),
                            _c("custom-switch-component", {
                              attrs: { value: _vm.currentSelectedActive },
                              on: { input: _vm.toggleSelectedActive }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                class: [
                                  "col-form-label",
                                  "ml-4",
                                  "d-inline",
                                  _vm.currentSelectedActive
                                    ? "text-success"
                                    : "text-secondary"
                                ]
                              },
                              [_vm._v("Enable")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    action.name == "delete"
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-block btn-md btn-danger btn-rounded",
                            attrs: {
                              type: "button",
                              disabled: !_vm._.size(_vm.selected)
                            },
                            on: { click: _vm.deleteSelected }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("delete")
                            ]),
                            _vm._v(
                              "\n                            Delete Selected\n                        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(action.component, {
                      key: action.name,
                      tag: "component",
                      attrs: {
                        content: _vm.content,
                        selected: _vm.selected,
                        addNotification: _vm.addNotification,
                        updateBatch: _vm.updateBatch,
                        createData: _vm.createData,
                        updateData: _vm.updateData,
                        deleteData: _vm.deleteData,
                        config: action
                      }
                    })
                  ]
                })
              ],
              2
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        class: [
          "control-panel-toggle d-flex align-items-center",
          _vm.open ? "open" : ""
        ],
        on: { click: _vm.closePanel }
      },
      [_c("i", { staticClass: "material-icons m-auto" }, [_vm._v("close")])]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "control-item-header no-border-top" }, [
      _c("span", { staticClass: "text" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("settings")]),
        _vm._v(" Selected")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71f2d15d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f2d15d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/ControlPanelComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-71f2d15d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/ControlPanelComponent.vue
// module chunks = 0